import React, { useState, useRef } from "react";

import isUrl from "is-url";
import { useSelector } from "react-redux";
import { useEditor } from "slate-react";

import URL$1 from "../../../../config/api";
import axios from "../../../../config/axios";

import "./styles.css";

const TextEditorInsertingModal = props => {
  const editor = useEditor();
  const inputRef = useRef();
  const [imageSrc, setImageSrc] = useState(undefined);
  const [imageUrlChecker, setImageUrlChecker] = useState("null");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState(undefined);
  const user = useSelector(state => state.user);

  const changeSelectedImage = selectedImage => {
    const file = new FormData();
    file.append("filepond", selectedImage);

    axios
      .post(`${URL$1.api}file/question_images/${user.user.id}`, file, {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "multipart/form-data"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          setImageSrc(URL$1.img + resp.data.url);
          setSelectedImage(selectedImage);
          setImageName(resp.data.name);
        }
      });
  };

  const checkUrl = url => {
    isUrl(url) ? setImageUrlChecker(true) : setImageUrlChecker(false);
  };

  const deleteImage = () => {
    const imageToDelete = {
      name: imageName
    };

    axios
      .post(
        `${URL$1.api}removeFile/question_images/${user.user.id}`,
        imageToDelete,
        { headers: { authorization: `Bearer ${user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          setImageName(undefined);
        }
      });
  };

  const cancelImageImporterModal = () => {
    if (!imageSrc && !selectedImage) return props.hideImageImporter();
    if (
      window.confirm(
        "Se você sair agora não enviará sua imagem. Deseja cancelar mesmo assim?"
      )
    ) {
      setImageSrc(undefined);
      setSelectedImage(null);
      setImageUrlChecker("null");
      props.hideImageImporter();
      deleteImage();
    }
  };

  return (
    <div
      className={
        props.show
          ? "image-importer-modal image-importer-display-block"
          : "image-importer-modal image-importer-display-none"
      }
    >
      <section className="image-importer-modal-main">
        <h5 className="mb-3">Selecione uma URL:</h5>
        <section className="url-image-importer">
          <input
            type="url"
            onKeyUp={e => {
              setImageSrc(e.target.value);
              checkUrl(e.target.value);
            }}
            className={
              imageUrlChecker
                ? "url-image-importer-true"
                : "url-image-importer-false"
            }
            placeholder="URL da imagem"
            readOnly={selectedImage !== null}
          />
          {!imageUrlChecker && selectedImage === null && (
            <p>Insira uma URL válida</p>
          )}
        </section>
        <h5 className="mb-3">Ou importe uma imagem:</h5>
        <section className="local-image-importer">
          <input
            type="file"
            accept="image/jpg, image/png"
            hidden
            ref={inputRef}
            onChange={e => changeSelectedImage(e.target.files[0])}
          />
          {selectedImage === null ? (
            <button
              onClick={() => {
                inputRef.current.click();
              }}
              className="local-image-importer-button"
            >
              Importar Imagem
            </button>
          ) : (
            <img src={imageSrc} alt="" className="locally-imported-image" />
          )}
        </section>
        <div className="image-importer-submit-menu">
          <button
            onClick={() => cancelImageImporterModal()}
            className="cancel-image-importer-button"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="btn submit-image-importer-button"
            disabled={!imageSrc}
            onMouseDown={e => {
              e.preventDefault();
              if (!imageSrc) return;
              props.insertImage(editor, imageSrc);
              setImageSrc(undefined);
              setSelectedImage(null);
              setImageUrlChecker("null");
              props.hideImageImporter();
            }}
          >
            Confirmar
          </button>
        </div>
      </section>
    </div>
  );
};

export default TextEditorInsertingModal;
